import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).then((reg) => reg.update().catch(() => {})).catch(() => {});
  });
}

const isChunkError = (msg) =>
  typeof msg === 'string' && /loading chunk|chunkloaderror|importing a module script failed|dynamically imported module/i.test(msg);

const recoverFromStaleCache = () => {
  if (sessionStorage.getItem('chunk_reload_done')) return;
  sessionStorage.setItem('chunk_reload_done', '1');
  const wipe = window.caches ? caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k)))) : Promise.resolve();
  wipe.finally(() => window.location.reload());
};

window.addEventListener('error', (e) => { if (isChunkError(e?.message)) recoverFromStaleCache(); });
window.addEventListener('unhandledrejection', (e) => {
  const r = e?.reason;
  if (r && (r.name === 'ChunkLoadError' || isChunkError(r.message))) recoverFromStaleCache();
});
